import React from 'react';
import './ProductIcon.css';

interface Props {
  id: string;
  size: number;
  title?: string;
}

const ProductIcon = (props: Props) => (
  <span
    title={props.title}
    aria-label={props.title}
    style={{ width: props.size, height: props.size }}
    className={`product-icon ${props.id}-ico`}
  />
);

export default ProductIcon;
